import * as React from "react";

//Images, Styles, State, Images
import '../../MainPage/MainPage.module.scss';
import DescriptionButtons from '../../images/button_descriptions.png'
import ViewDescriptions from '../../images/description_lightbox.png'
import RefineSearch from '../../images/filter_instructions.png'
import SearchFilter from '../../images/Search_Filter_Instructions.png'
import styles from './Instructions.module.scss'

//Instructions Component. Holds the information and images stored in the instructions accordion.
// TODO: Refactor Instructions images as the UI is changed
export default function Instructions(): JSX.Element {
    return (
        <div>
            <div className={styles.container}>
                <div className={styles.filteringTopic}>
                    <h3>Filtering Topic(s)</h3>
                    <hr />
                    <p>To begin searching, select the topics you want to display on the table from one of the drop-downs. </p>
                    {/* Search Image */}
                    <img src={RefineSearch} alt="Search Topics" style={{ maxWidth: '100%' }} />

                    <div className={styles.searchFilter}>
                    <img src={SearchFilter} alt="Search Filter" style={{ maxWidth: '25%' }} />
                        <p className={styles.rightText}>After the topic(s) have been selected, the table will update to include fields from each topic. Next, select the state(s) from the state drop-down. <p> You have the option to search through each drop-down filter. Typing in a key word or phrase will change the list to related fields.</p></p>

                    </div>
                </div>

                <div className={styles.howToSearch}>
                    <h3>How to search OPUS</h3>
                    <hr />
                    <p>Opus is sorted by Topics and States in alphabetical order. Multiple Topics/States can be viewed at the same time. Headers and States can also be selected/unselected for a more customizable option. </p>

                    <h3>Viewing Descriptions</h3>
                    <hr />
                    <p>Once a Topic(s)/State(s) is chosen,  a chip with the Topic name will be displayed.</p>
                    <img  src={DescriptionButtons} alt="Description Buttons" style={{ maxWidth: '100%' }} />
                  
                    <div className={styles.description}>
                    <p className={styles.leftText}>Clicking on the chip will bring a pop up window that describes the chosen topic.</p>
                        <img src={ViewDescriptions} alt="Description View" style={{ maxWidth: '50%' }} />
                        
                    </div>
                </div>
            </div>
        </div>
    )
};
